import { Signer } from '@breathelife/types';
import { PdfDocumentType } from '@zinnia/form-engine-sdk';

import ApiService from './ApiService';

export async function processParticipants(applicationId: string): Promise<Partial<Record<PdfDocumentType, Signer[]>>> {
  const response = await ApiService.processParticipants(applicationId);
  return response.data;
}
